var map = {
	"./af": "./node_modules/_moment@2.29.4@moment/dist/locale/af.js",
	"./af.js": "./node_modules/_moment@2.29.4@moment/dist/locale/af.js",
	"./ar": "./node_modules/_moment@2.29.4@moment/dist/locale/ar.js",
	"./ar-dz": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-dz.js",
	"./ar-kw": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-kw.js",
	"./ar-ly": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-ly.js",
	"./ar-ma": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-ma.js",
	"./ar-sa": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-sa.js",
	"./ar-tn": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar-tn.js",
	"./ar.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ar.js",
	"./az": "./node_modules/_moment@2.29.4@moment/dist/locale/az.js",
	"./az.js": "./node_modules/_moment@2.29.4@moment/dist/locale/az.js",
	"./be": "./node_modules/_moment@2.29.4@moment/dist/locale/be.js",
	"./be.js": "./node_modules/_moment@2.29.4@moment/dist/locale/be.js",
	"./bg": "./node_modules/_moment@2.29.4@moment/dist/locale/bg.js",
	"./bg.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bg.js",
	"./bm": "./node_modules/_moment@2.29.4@moment/dist/locale/bm.js",
	"./bm.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bm.js",
	"./bn": "./node_modules/_moment@2.29.4@moment/dist/locale/bn.js",
	"./bn-bd": "./node_modules/_moment@2.29.4@moment/dist/locale/bn-bd.js",
	"./bn-bd.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bn-bd.js",
	"./bn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bn.js",
	"./bo": "./node_modules/_moment@2.29.4@moment/dist/locale/bo.js",
	"./bo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bo.js",
	"./br": "./node_modules/_moment@2.29.4@moment/dist/locale/br.js",
	"./br.js": "./node_modules/_moment@2.29.4@moment/dist/locale/br.js",
	"./bs": "./node_modules/_moment@2.29.4@moment/dist/locale/bs.js",
	"./bs.js": "./node_modules/_moment@2.29.4@moment/dist/locale/bs.js",
	"./ca": "./node_modules/_moment@2.29.4@moment/dist/locale/ca.js",
	"./ca.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ca.js",
	"./cs": "./node_modules/_moment@2.29.4@moment/dist/locale/cs.js",
	"./cs.js": "./node_modules/_moment@2.29.4@moment/dist/locale/cs.js",
	"./cv": "./node_modules/_moment@2.29.4@moment/dist/locale/cv.js",
	"./cv.js": "./node_modules/_moment@2.29.4@moment/dist/locale/cv.js",
	"./cy": "./node_modules/_moment@2.29.4@moment/dist/locale/cy.js",
	"./cy.js": "./node_modules/_moment@2.29.4@moment/dist/locale/cy.js",
	"./da": "./node_modules/_moment@2.29.4@moment/dist/locale/da.js",
	"./da.js": "./node_modules/_moment@2.29.4@moment/dist/locale/da.js",
	"./de": "./node_modules/_moment@2.29.4@moment/dist/locale/de.js",
	"./de-at": "./node_modules/_moment@2.29.4@moment/dist/locale/de-at.js",
	"./de-at.js": "./node_modules/_moment@2.29.4@moment/dist/locale/de-at.js",
	"./de-ch": "./node_modules/_moment@2.29.4@moment/dist/locale/de-ch.js",
	"./de-ch.js": "./node_modules/_moment@2.29.4@moment/dist/locale/de-ch.js",
	"./de.js": "./node_modules/_moment@2.29.4@moment/dist/locale/de.js",
	"./dv": "./node_modules/_moment@2.29.4@moment/dist/locale/dv.js",
	"./dv.js": "./node_modules/_moment@2.29.4@moment/dist/locale/dv.js",
	"./el": "./node_modules/_moment@2.29.4@moment/dist/locale/el.js",
	"./el.js": "./node_modules/_moment@2.29.4@moment/dist/locale/el.js",
	"./en-au": "./node_modules/_moment@2.29.4@moment/dist/locale/en-au.js",
	"./en-au.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-au.js",
	"./en-ca": "./node_modules/_moment@2.29.4@moment/dist/locale/en-ca.js",
	"./en-ca.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-ca.js",
	"./en-gb": "./node_modules/_moment@2.29.4@moment/dist/locale/en-gb.js",
	"./en-gb.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-gb.js",
	"./en-ie": "./node_modules/_moment@2.29.4@moment/dist/locale/en-ie.js",
	"./en-ie.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-ie.js",
	"./en-il": "./node_modules/_moment@2.29.4@moment/dist/locale/en-il.js",
	"./en-il.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-il.js",
	"./en-in": "./node_modules/_moment@2.29.4@moment/dist/locale/en-in.js",
	"./en-in.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-in.js",
	"./en-nz": "./node_modules/_moment@2.29.4@moment/dist/locale/en-nz.js",
	"./en-nz.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-nz.js",
	"./en-sg": "./node_modules/_moment@2.29.4@moment/dist/locale/en-sg.js",
	"./en-sg.js": "./node_modules/_moment@2.29.4@moment/dist/locale/en-sg.js",
	"./eo": "./node_modules/_moment@2.29.4@moment/dist/locale/eo.js",
	"./eo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/eo.js",
	"./es": "./node_modules/_moment@2.29.4@moment/dist/locale/es.js",
	"./es-do": "./node_modules/_moment@2.29.4@moment/dist/locale/es-do.js",
	"./es-do.js": "./node_modules/_moment@2.29.4@moment/dist/locale/es-do.js",
	"./es-mx": "./node_modules/_moment@2.29.4@moment/dist/locale/es-mx.js",
	"./es-mx.js": "./node_modules/_moment@2.29.4@moment/dist/locale/es-mx.js",
	"./es-us": "./node_modules/_moment@2.29.4@moment/dist/locale/es-us.js",
	"./es-us.js": "./node_modules/_moment@2.29.4@moment/dist/locale/es-us.js",
	"./es.js": "./node_modules/_moment@2.29.4@moment/dist/locale/es.js",
	"./et": "./node_modules/_moment@2.29.4@moment/dist/locale/et.js",
	"./et.js": "./node_modules/_moment@2.29.4@moment/dist/locale/et.js",
	"./eu": "./node_modules/_moment@2.29.4@moment/dist/locale/eu.js",
	"./eu.js": "./node_modules/_moment@2.29.4@moment/dist/locale/eu.js",
	"./fa": "./node_modules/_moment@2.29.4@moment/dist/locale/fa.js",
	"./fa.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fa.js",
	"./fi": "./node_modules/_moment@2.29.4@moment/dist/locale/fi.js",
	"./fi.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fi.js",
	"./fil": "./node_modules/_moment@2.29.4@moment/dist/locale/fil.js",
	"./fil.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fil.js",
	"./fo": "./node_modules/_moment@2.29.4@moment/dist/locale/fo.js",
	"./fo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fo.js",
	"./fr": "./node_modules/_moment@2.29.4@moment/dist/locale/fr.js",
	"./fr-ca": "./node_modules/_moment@2.29.4@moment/dist/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fr-ca.js",
	"./fr-ch": "./node_modules/_moment@2.29.4@moment/dist/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fr-ch.js",
	"./fr.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fr.js",
	"./fy": "./node_modules/_moment@2.29.4@moment/dist/locale/fy.js",
	"./fy.js": "./node_modules/_moment@2.29.4@moment/dist/locale/fy.js",
	"./ga": "./node_modules/_moment@2.29.4@moment/dist/locale/ga.js",
	"./ga.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ga.js",
	"./gd": "./node_modules/_moment@2.29.4@moment/dist/locale/gd.js",
	"./gd.js": "./node_modules/_moment@2.29.4@moment/dist/locale/gd.js",
	"./gl": "./node_modules/_moment@2.29.4@moment/dist/locale/gl.js",
	"./gl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/gl.js",
	"./gom-deva": "./node_modules/_moment@2.29.4@moment/dist/locale/gom-deva.js",
	"./gom-deva.js": "./node_modules/_moment@2.29.4@moment/dist/locale/gom-deva.js",
	"./gom-latn": "./node_modules/_moment@2.29.4@moment/dist/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/gom-latn.js",
	"./gu": "./node_modules/_moment@2.29.4@moment/dist/locale/gu.js",
	"./gu.js": "./node_modules/_moment@2.29.4@moment/dist/locale/gu.js",
	"./he": "./node_modules/_moment@2.29.4@moment/dist/locale/he.js",
	"./he.js": "./node_modules/_moment@2.29.4@moment/dist/locale/he.js",
	"./hi": "./node_modules/_moment@2.29.4@moment/dist/locale/hi.js",
	"./hi.js": "./node_modules/_moment@2.29.4@moment/dist/locale/hi.js",
	"./hr": "./node_modules/_moment@2.29.4@moment/dist/locale/hr.js",
	"./hr.js": "./node_modules/_moment@2.29.4@moment/dist/locale/hr.js",
	"./hu": "./node_modules/_moment@2.29.4@moment/dist/locale/hu.js",
	"./hu.js": "./node_modules/_moment@2.29.4@moment/dist/locale/hu.js",
	"./hy-am": "./node_modules/_moment@2.29.4@moment/dist/locale/hy-am.js",
	"./hy-am.js": "./node_modules/_moment@2.29.4@moment/dist/locale/hy-am.js",
	"./id": "./node_modules/_moment@2.29.4@moment/dist/locale/id.js",
	"./id.js": "./node_modules/_moment@2.29.4@moment/dist/locale/id.js",
	"./is": "./node_modules/_moment@2.29.4@moment/dist/locale/is.js",
	"./is.js": "./node_modules/_moment@2.29.4@moment/dist/locale/is.js",
	"./it": "./node_modules/_moment@2.29.4@moment/dist/locale/it.js",
	"./it-ch": "./node_modules/_moment@2.29.4@moment/dist/locale/it-ch.js",
	"./it-ch.js": "./node_modules/_moment@2.29.4@moment/dist/locale/it-ch.js",
	"./it.js": "./node_modules/_moment@2.29.4@moment/dist/locale/it.js",
	"./ja": "./node_modules/_moment@2.29.4@moment/dist/locale/ja.js",
	"./ja.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ja.js",
	"./jv": "./node_modules/_moment@2.29.4@moment/dist/locale/jv.js",
	"./jv.js": "./node_modules/_moment@2.29.4@moment/dist/locale/jv.js",
	"./ka": "./node_modules/_moment@2.29.4@moment/dist/locale/ka.js",
	"./ka.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ka.js",
	"./kk": "./node_modules/_moment@2.29.4@moment/dist/locale/kk.js",
	"./kk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/kk.js",
	"./km": "./node_modules/_moment@2.29.4@moment/dist/locale/km.js",
	"./km.js": "./node_modules/_moment@2.29.4@moment/dist/locale/km.js",
	"./kn": "./node_modules/_moment@2.29.4@moment/dist/locale/kn.js",
	"./kn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/kn.js",
	"./ko": "./node_modules/_moment@2.29.4@moment/dist/locale/ko.js",
	"./ko.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ko.js",
	"./ku": "./node_modules/_moment@2.29.4@moment/dist/locale/ku.js",
	"./ku.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ku.js",
	"./ky": "./node_modules/_moment@2.29.4@moment/dist/locale/ky.js",
	"./ky.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ky.js",
	"./lb": "./node_modules/_moment@2.29.4@moment/dist/locale/lb.js",
	"./lb.js": "./node_modules/_moment@2.29.4@moment/dist/locale/lb.js",
	"./lo": "./node_modules/_moment@2.29.4@moment/dist/locale/lo.js",
	"./lo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/lo.js",
	"./lt": "./node_modules/_moment@2.29.4@moment/dist/locale/lt.js",
	"./lt.js": "./node_modules/_moment@2.29.4@moment/dist/locale/lt.js",
	"./lv": "./node_modules/_moment@2.29.4@moment/dist/locale/lv.js",
	"./lv.js": "./node_modules/_moment@2.29.4@moment/dist/locale/lv.js",
	"./me": "./node_modules/_moment@2.29.4@moment/dist/locale/me.js",
	"./me.js": "./node_modules/_moment@2.29.4@moment/dist/locale/me.js",
	"./mi": "./node_modules/_moment@2.29.4@moment/dist/locale/mi.js",
	"./mi.js": "./node_modules/_moment@2.29.4@moment/dist/locale/mi.js",
	"./mk": "./node_modules/_moment@2.29.4@moment/dist/locale/mk.js",
	"./mk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/mk.js",
	"./ml": "./node_modules/_moment@2.29.4@moment/dist/locale/ml.js",
	"./ml.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ml.js",
	"./mn": "./node_modules/_moment@2.29.4@moment/dist/locale/mn.js",
	"./mn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/mn.js",
	"./mr": "./node_modules/_moment@2.29.4@moment/dist/locale/mr.js",
	"./mr.js": "./node_modules/_moment@2.29.4@moment/dist/locale/mr.js",
	"./ms": "./node_modules/_moment@2.29.4@moment/dist/locale/ms.js",
	"./ms-my": "./node_modules/_moment@2.29.4@moment/dist/locale/ms-my.js",
	"./ms-my.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ms-my.js",
	"./ms.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ms.js",
	"./mt": "./node_modules/_moment@2.29.4@moment/dist/locale/mt.js",
	"./mt.js": "./node_modules/_moment@2.29.4@moment/dist/locale/mt.js",
	"./my": "./node_modules/_moment@2.29.4@moment/dist/locale/my.js",
	"./my.js": "./node_modules/_moment@2.29.4@moment/dist/locale/my.js",
	"./nb": "./node_modules/_moment@2.29.4@moment/dist/locale/nb.js",
	"./nb.js": "./node_modules/_moment@2.29.4@moment/dist/locale/nb.js",
	"./ne": "./node_modules/_moment@2.29.4@moment/dist/locale/ne.js",
	"./ne.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ne.js",
	"./nl": "./node_modules/_moment@2.29.4@moment/dist/locale/nl.js",
	"./nl-be": "./node_modules/_moment@2.29.4@moment/dist/locale/nl-be.js",
	"./nl-be.js": "./node_modules/_moment@2.29.4@moment/dist/locale/nl-be.js",
	"./nl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/nl.js",
	"./nn": "./node_modules/_moment@2.29.4@moment/dist/locale/nn.js",
	"./nn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/nn.js",
	"./oc-lnc": "./node_modules/_moment@2.29.4@moment/dist/locale/oc-lnc.js",
	"./oc-lnc.js": "./node_modules/_moment@2.29.4@moment/dist/locale/oc-lnc.js",
	"./pa-in": "./node_modules/_moment@2.29.4@moment/dist/locale/pa-in.js",
	"./pa-in.js": "./node_modules/_moment@2.29.4@moment/dist/locale/pa-in.js",
	"./pl": "./node_modules/_moment@2.29.4@moment/dist/locale/pl.js",
	"./pl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/pl.js",
	"./pt": "./node_modules/_moment@2.29.4@moment/dist/locale/pt.js",
	"./pt-br": "./node_modules/_moment@2.29.4@moment/dist/locale/pt-br.js",
	"./pt-br.js": "./node_modules/_moment@2.29.4@moment/dist/locale/pt-br.js",
	"./pt.js": "./node_modules/_moment@2.29.4@moment/dist/locale/pt.js",
	"./ro": "./node_modules/_moment@2.29.4@moment/dist/locale/ro.js",
	"./ro.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ro.js",
	"./ru": "./node_modules/_moment@2.29.4@moment/dist/locale/ru.js",
	"./ru.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ru.js",
	"./sd": "./node_modules/_moment@2.29.4@moment/dist/locale/sd.js",
	"./sd.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sd.js",
	"./se": "./node_modules/_moment@2.29.4@moment/dist/locale/se.js",
	"./se.js": "./node_modules/_moment@2.29.4@moment/dist/locale/se.js",
	"./si": "./node_modules/_moment@2.29.4@moment/dist/locale/si.js",
	"./si.js": "./node_modules/_moment@2.29.4@moment/dist/locale/si.js",
	"./sk": "./node_modules/_moment@2.29.4@moment/dist/locale/sk.js",
	"./sk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sk.js",
	"./sl": "./node_modules/_moment@2.29.4@moment/dist/locale/sl.js",
	"./sl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sl.js",
	"./sq": "./node_modules/_moment@2.29.4@moment/dist/locale/sq.js",
	"./sq.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sq.js",
	"./sr": "./node_modules/_moment@2.29.4@moment/dist/locale/sr.js",
	"./sr-cyrl": "./node_modules/_moment@2.29.4@moment/dist/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sr.js",
	"./ss": "./node_modules/_moment@2.29.4@moment/dist/locale/ss.js",
	"./ss.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ss.js",
	"./sv": "./node_modules/_moment@2.29.4@moment/dist/locale/sv.js",
	"./sv.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sv.js",
	"./sw": "./node_modules/_moment@2.29.4@moment/dist/locale/sw.js",
	"./sw.js": "./node_modules/_moment@2.29.4@moment/dist/locale/sw.js",
	"./ta": "./node_modules/_moment@2.29.4@moment/dist/locale/ta.js",
	"./ta.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ta.js",
	"./te": "./node_modules/_moment@2.29.4@moment/dist/locale/te.js",
	"./te.js": "./node_modules/_moment@2.29.4@moment/dist/locale/te.js",
	"./tet": "./node_modules/_moment@2.29.4@moment/dist/locale/tet.js",
	"./tet.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tet.js",
	"./tg": "./node_modules/_moment@2.29.4@moment/dist/locale/tg.js",
	"./tg.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tg.js",
	"./th": "./node_modules/_moment@2.29.4@moment/dist/locale/th.js",
	"./th.js": "./node_modules/_moment@2.29.4@moment/dist/locale/th.js",
	"./tk": "./node_modules/_moment@2.29.4@moment/dist/locale/tk.js",
	"./tk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tk.js",
	"./tl-ph": "./node_modules/_moment@2.29.4@moment/dist/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tl-ph.js",
	"./tlh": "./node_modules/_moment@2.29.4@moment/dist/locale/tlh.js",
	"./tlh.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tlh.js",
	"./tr": "./node_modules/_moment@2.29.4@moment/dist/locale/tr.js",
	"./tr.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tr.js",
	"./tzl": "./node_modules/_moment@2.29.4@moment/dist/locale/tzl.js",
	"./tzl.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tzl.js",
	"./tzm": "./node_modules/_moment@2.29.4@moment/dist/locale/tzm.js",
	"./tzm-latn": "./node_modules/_moment@2.29.4@moment/dist/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/_moment@2.29.4@moment/dist/locale/tzm.js",
	"./ug-cn": "./node_modules/_moment@2.29.4@moment/dist/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ug-cn.js",
	"./uk": "./node_modules/_moment@2.29.4@moment/dist/locale/uk.js",
	"./uk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/uk.js",
	"./ur": "./node_modules/_moment@2.29.4@moment/dist/locale/ur.js",
	"./ur.js": "./node_modules/_moment@2.29.4@moment/dist/locale/ur.js",
	"./uz": "./node_modules/_moment@2.29.4@moment/dist/locale/uz.js",
	"./uz-latn": "./node_modules/_moment@2.29.4@moment/dist/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/uz-latn.js",
	"./uz.js": "./node_modules/_moment@2.29.4@moment/dist/locale/uz.js",
	"./vi": "./node_modules/_moment@2.29.4@moment/dist/locale/vi.js",
	"./vi.js": "./node_modules/_moment@2.29.4@moment/dist/locale/vi.js",
	"./x-pseudo": "./node_modules/_moment@2.29.4@moment/dist/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/x-pseudo.js",
	"./yo": "./node_modules/_moment@2.29.4@moment/dist/locale/yo.js",
	"./yo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/yo.js",
	"./zh-cn": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-cn.js",
	"./zh-hk": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-hk.js",
	"./zh-mo": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-mo.js",
	"./zh-mo.js": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-mo.js",
	"./zh-tw": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/_moment@2.29.4@moment/dist/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/_moment@2.29.4@moment/dist/locale sync recursive ^\\.\\/.*$";